import React, { useMemo, useState, useEffect, useCallback, useContext, useRef } from "react";
import { Grid, Stack } from "@mui/material";
import {
  titleCase,
  formatStatus,
} from "../../../Components/FormattingFunctions";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./ProjectProfile.css";
import BackBtn from "../../../assets/BackBtn.svg";
import Dropdown from "../../../Components/DropDownSelect/Dropdown";
import EditDiv from "../../../Components/EditDiv/EditDiv";
import AdminContext from "../../../Context/adminContext";
import { useMsal } from "@azure/msal-react";
import EditIcon from "../../../assets/Edit.svg";
import MapPin from "../../../assets/MapPin.svg";
import FolderIcon from "../../../assets/folder.svg";
import Skeleton from "@mui/material/Skeleton";
import { Box, CircularProgress } from "@mui/material";
import { useSnackbar } from 'notistack';
import "../../../Components/YesNoButtonsCSS/YesNoButtons.css";
import ProgressBar from "../../../Components/ProgressBar/ProgressBar";
import Table from "../../../Components/Table/TableV2";
import HorizontalButtons from "../../../Components/HorizontalButtons/HorizontalButtons";

import PhaseTable from "../../../Sections/projects/PhaseTable";
import PlannedInvoicedTable from "../../../Sections/projects/PlannedInvoicedTable";
import BillPayerTable from "../../../Sections/projects/BillPayerTable";

import AppointedPopUp from "../../../Components/AppointedPopUp/AppointedPopUp";
import LostOppPopUp from "../../../Components/LostOppPopUp/LostOppPopUp";
import FollowUpPopUp from "../../../Components/FollowUpPopUp/FollowUpPopUp";
import AddBillPayerPopUp from "../../../Sections/projects/AddBillPayerPopUp";
import PhasePopUp from "../../../Sections/projects/PhasePopup";
import PlannedInvoicedPopUp from "../../../Sections/projects/PlannedInvoicedPopUp";
import PlannerTasksBoard from "../../../Components/PlannerTasksBoard/PlannerTasksBoard";

import { useDispatch, useSelector } from '../../../redux/store';

import {
  postUpdateClient,
  postAWF,
  postSubConForm,
  deleteBillingPlan,
  postRequestFreshFBPandFP,
} from "../../../redux/slices/project";
import { getRunners } from "../../../redux/slices/opportunitiesdata";
import { fetchTeamOptions } from '../../../redux/slices/options';
import { fetchPlannerTasks, clearPlannerTasks } from '../../../redux/slices/plannerTasks';
import { sendProjectToVm } from '../../../redux/slices/settings';
import {
  fetchOpportunityLostReasons,
  fetchProjectBillPayers,
  fetchProjectPhases,
  fetchProjectPlannedInvoices,
  fetchProjectProfileFilters,
  fetchProjectProfileInfo,
  fetchProjectProfileLogBook,
  fetchProjectProfileTimesheets,
  postProjectComment,
  postProjectUpdateInfo,
} from '../../../redux/slices/projectProfile';

import AWForm from "../../../Components/AWForm/AWForm";
import SubcontractorForm from "../../../Components/SubcontractorForm/SubcontractorForm";
import UpdateAddressPopUp from "../../../Components/UpdateAddressPopUp/UpdateAddressPopUp";
import StructuralSpecificationForm from "../../../Components/StructuralForms/StructuralSpecificationForm";
import UpdateClientForm from "../../../Components/ProjectClientForm/ProjectClientForm";
import TriageBookingModal from "../../../Components/TriageBookingModal/TriageBookingModal";
import RisksOptionsForm from "../../../Components/RisksOptions/RisksOptionsForm";

function ProjectProfile() {
  const { accounts } = useMsal();
  const account = accounts[0];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const jobno = useMemo(() => {
    const raw = (location?.hash || '').replace('#', '');
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }, [location?.hash]);
  const [jobData, setJobData] = useState(null);
  const [lastUpdated, setLastUpdated] = useState("");

  const [status_type_options, setStatusTypes] = useState([]);
  const [statusActivityMap, setActivityMap] = useState([]);
  const [logBook, AssignLogBook] = useState([]);
  const [isLogBookLoading, setIsLogBookLoading] = useState(true);

  const [loading, setLoading] = useState(false);
  const [isResponseShown, setIsResponseShown] = useState(false);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [promoteModal, setPromoteModal] = useState(false);
  const [lostOppModal, setLostOppModal] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  const commentInputRef = useRef(null);
  const pulsatingTime = 500; // 5 seconds in milliseconds

  const [currentData, setCurrentData] = useState(null);
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  // const [text, setText] = useState('');
  const [displayEditDiv, setDisplayEditDiv] = useState(false);
  const [timesheetData, setTimesheetData] = useState([]);
  const [addressEditInfo, setAddressEdit] = useState([]);
  const [runnerTeamEditInfo, setRunnerTeamEdit] = useState([]);
  const [statsEditInfo, setStatsEdit] = useState([]);
  const [FollowUpEditInfo, setFollowUpEdit] = useState([]);

  // Runner options now come from the shared opportunities slice
  const { runners: runnerOptions } = useSelector((state) => state.opportunities || { runners: [] });
  const plannerTasks = useSelector((state) => state.plannerTasks);
  const [lostReasons, setLostReasons] = useState([]);
  const [editType, setEditType] = useState("UPDATE");
  const [selectedValue, setSelectedValue] = useState("SUMMARY - PHASE");
  const [timesheetLoading, setTimesheetLoading] = useState(false);
  const [timesheetError, setTimesheetError] = useState(null);

  // Form
  const [displayUpdateClientForm, setDisplayUpdateClientForm] = useState(false);
  const [displayAWForm, setDisplayAWForm] = useState(false);
  const [displaySubconForm, setDisplaySubconForm] = useState(false);
  const [showTriageModal, setShowTriageModal] = useState(false);
  const [displayUpdateAddress, setDisplayUpdateAddress] = useState(false);
  const [showRisksOptions, setShowRisksOptions] = useState(false);
  const [showStructuralSpec, setShowStructuralSpec] = useState(false);
  const [addressEditData, setAddressEditData] = useState(null);
  const [tsdLoading, setTsdLoading] = useState(false);

  //Phase States
  const [phaseListLoading, setPhaseListLoading] = useState(false);
  const [phaseListData, setPhaseListData] = useState({});
  const [phaseModal, setPhaseModal] = useState(false);
  const [isUpdatingPhase, setIsUpdatingPhase] = useState(false);
  const [selectedPhase, setSelectedPhase] = useState({});

  //invoices States
  const [pInvoiceListLoading, setpInvoiceListLoading] = useState(false);
  const [pInvoiceListData, setpInvoiceListData] = useState({});
  const [pInvoiceModal, setpInvoiceModal] = useState(false);
  const [isUpdatingPInvoice, setIsUpdatingPInvoice] = useState(false);
  const [selectedPInvocied, setSelectedPInvoice] = useState({});
  const editable = useContext(AdminContext);
  const [InvoicedData, setInvoicedData] = useState([]);
  const [activeTab, setActiveTab] = useState('Logbook');

  // Bill payer states
  const [billPayerLoading, setBillPayerLoading] = useState(false);
  const [billPayerData, setBillPayerData] = useState({});
  const [billPayerModal, setAddBillPayerModal] = useState(false);

  const loadPromisesRef = useRef([]);
  const isCancelError = useCallback((e) => {
    return e?.name === 'AbortError' || e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError';
  }, []);

  useEffect(() => {
    // Parse the URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const scrollParam = queryParams.get("scroll");

    console.log(scrollParam);

    if (scrollParam) {
      if (scrollParam === "Logbook") {
        setActiveTab("Logbook");
      }
      // Scroll to the section with the ID that matches the 'scroll' query parameter
      const section = document.getElementById(scrollParam);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]); // This will run when the location (URL) changes

  const fetchDataRecords = async () => {
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectProfileInfo({ projectNumber: jobno }));
      loadPromisesRef.current.push(promise);
      const data = await promise.unwrap();
      setJobData(data);
      setAddressEdit(data?.UpdateProjectAddress);
      setRunnerTeamEdit(data?.UpdateProjectInfo);
      setStatsEdit(data?.UpdateProjectStats);
      setFollowUpEdit(data?.UpdateFollowUpDate);

    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching project data:", error);
    }
  };

  const fetchTimesheetData = async () => {
    setTimesheetLoading(true);
    setTimesheetError(null);
    const viewMode = selectedValue;
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectProfileTimesheets({ projectNumber: jobno, mode: viewMode }));
      loadPromisesRef.current.push(promise);
      const data = await promise.unwrap();
      const timesheetEntries = data?.TimesheetData;
      setTimesheetData(timesheetEntries);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching timesheet data:", error);
      setTimesheetError(
        typeof error === "string"
          ? error
          : (error?.message || "Timesheets failed to load (server error).")
      );
    } finally {
      setTimesheetLoading(false);
    }
  };

  const fetchLogBook = async () => {
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectProfileLogBook({ projectNumber: jobno }));
      loadPromisesRef.current.push(promise);
      const data = await promise.unwrap();
      AssignLogBook(data);
      setIsLogBookLoading(false);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching project logbook:", error);
      setIsLogBookLoading(false);
    }
  };

  const fetchFilters = async () => {
    try {
      const promise = dispatch(fetchProjectProfileFilters());
      loadPromisesRef.current.push(promise);
      const data = await promise.unwrap();
      setActivityMap(data);

      // Extract the keys from the result.data object and store them in a list
      const activityKeys = Object.keys(data || {});

      // Sort the keys in descending order based on the number of elements in their corresponding values array
      activityKeys.sort(
        (a, b) => (data?.[b]?.length || 0) - (data?.[a]?.length || 0)
      );

      setStatusTypes(activityKeys);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching project status:", error);
    }
  };

  const fetchLostReasons = async () => {
    try {
      const promise = dispatch(fetchOpportunityLostReasons());
      loadPromisesRef.current.push(promise);
      const data = await promise.unwrap();
      setLostReasons(data?.data?.lostReasons || []);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching project status:", error);
    }
  };

  const fetchBillPayers = async () => {
    setBillPayerLoading(true);
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectBillPayers({ projectNumber: jobno }));
      loadPromisesRef.current.push(promise);
      const response = await promise.unwrap();
      // const data = {
      //   data: response.data.data,
      //   totalPromoted: 222,
      //   totalQuoted: 22,
      // };
      // Thunks return `res.data`, but some older UI code expects nested `.data.data`.
      // Normalize to an array for downstream tables.
      const payload = response?.data?.data ?? response?.data ?? response;
      const billPayersArray = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
      setBillPayerData(billPayersArray);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching timesheet data:", error);
    } finally {
      setBillPayerLoading(false);
    }
  };

  const fetchPhaseList = async () => {
    setPhaseListLoading(true);
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectPhases({ projectNumber: jobno }));
      loadPromisesRef.current.push(promise);
      const response = await promise.unwrap();
      const payload = response?.data?.data ?? response?.data ?? response;
      const phasesArray = Array.isArray(payload?.phases)
        ? payload.phases
        : (Array.isArray(payload?.data?.phases) ? payload.data.phases : (Array.isArray(payload) ? payload : []));
      const data = {
        data: phasesArray,
        totalPromoted: payload?.totalPromoted ?? payload?.data?.totalPromoted ?? 0,
        totalQuoted: payload?.totalQuoted ?? payload?.data?.totalQuoted ?? 0,
      };
      setPhaseListData(data);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching timesheet data:", error);
    } finally {
      setPhaseListLoading(false);
    }
  };

  const fetchpInvoiceList = async () => {
    setpInvoiceListLoading(true);
    try {
      if (!jobno) return;
      const promise = dispatch(fetchProjectPlannedInvoices({ projectNumber: jobno }));
      loadPromisesRef.current.push(promise);
      const response = await promise.unwrap();
      const payload = response?.data?.data ?? response?.data ?? response;
      const invoicesArray = Array.isArray(payload?.invoices)
        ? payload.invoices
        : (Array.isArray(payload?.data?.invoices) ? payload.data.invoices : (Array.isArray(payload) ? payload : []));
      const data = {
        data: invoicesArray,
        totalPlannedAmount: payload?.totalPlannedAmount ?? payload?.data?.totalPlannedAmount ?? 0,
        totalInvoicedAmount: payload?.totalInvoicedAmount ?? payload?.data?.totalInvoicedAmount ?? 0,
      };
      setpInvoiceListData(data);
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching timesheet data:", error);
    } finally {
      setpInvoiceListLoading(false);
    }
  };

  const fetchPlannerTasksData = async () => {
    if (!jobno) return;
    try {
      const promise = dispatch(fetchPlannerTasks({ jobNumber: jobno }));
      loadPromisesRef.current.push(promise);
      await promise.unwrap();
    } catch (error) {
      if (isCancelError(error)) return;
      console.error("Error fetching planner tasks:", error);
    }
  };

  useEffect(() => {
    // Listen for task completion refresh events whenever they happen on this page
    const handleTaskRefresh = () => {
      fetchPlannerTasksData();
    };
    window.addEventListener('personalTasks:refresh', handleTaskRefresh);

    return () => {
      window.removeEventListener('personalTasks:refresh', handleTaskRefresh);
    };
  }, [jobno]);

  useEffect(() => {
    // Abort any previous in-flight thunks (important for clean navigation in prod)
    if (loadPromisesRef.current && Array.isArray(loadPromisesRef.current)) {
      loadPromisesRef.current.forEach((p) => {
        try {
          if (p && typeof p.abort === 'function') {
            p.abort();
          }
        } catch (error) {
          console.warn('Failed to abort promise on setup:', error);
        }
      });
    }
    loadPromisesRef.current = [];

    // Only load when we have a valid project number and an authenticated user
    if (!jobno || !account?.username) return () => undefined;

    // Shared options
    loadPromisesRef.current.push(dispatch(fetchTeamOptions()));
    loadPromisesRef.current.push(dispatch(getRunners()));

    // Page data
    fetchDataRecords();
    fetchLogBook();
    fetchFilters();
    fetchLostReasons();
    fetchPhaseList();
    fetchpInvoiceList();
    fetchBillPayers();
    fetchPlannerTasksData();

    return () => {
      if (loadPromisesRef.current && Array.isArray(loadPromisesRef.current)) {
        loadPromisesRef.current.forEach((p) => {
          try {
            if (p && typeof p.abort === 'function') {
              p.abort();
            }
          } catch (error) {
            console.warn('Failed to abort promise on unmount:', error);
          }
        });
      }
      loadPromisesRef.current = [];
    };
  }, [dispatch, jobno, account?.username]);

  useEffect(() => {
    if (jobData && jobData.status) {
      let formattedStatus;
      if (jobData.status === "ON HOLD") {
        formattedStatus = formatStatus(jobData.status);
      } else if (jobData.status !== null) {
        formattedStatus = titleCase(jobData.status);
      }
      setStatus(formattedStatus);
    }
  }, [jobData]);

  const handleUpdateClick = async (DataTitle, selectedValues) => {
    if (DataTitle == "Update Follow Up Date") {
      if (handlePostBtnClick() == "Invalid") {
        return;
      }
    }



    setLoading(true);
    // console.log('DataTitle, selectedValues: ', DataTitle, selectedValues);
    try {
      const data = await dispatch(postProjectUpdateInfo({
        projectNumber: jobno,
        userEmail: account.username,
        sectionName: DataTitle,
        updatedValues: selectedValues,
      })).unwrap();

      const message = typeof data?.message === "string" && data.message.trim() !== "" ? data.message : "Update completed.";
      if (DataTitle != "Update Follow Up Date") setApiResponse(message);
    } catch (error) {
      console.error("Error in Project Update API:", error);
      if (DataTitle != "Update Follow Up Date") setApiResponse("An unexpected error occurred while updating the project.");
    } finally {
      setLoading(false);
      fetchDataRecords();
      // fetchTimesheetData();
      fetchLogBook();
      fetchPhaseList();
      if (DataTitle != "Update Follow Up Date") {
        // Only show the popup when there is a message to display
        setIsResponseShown((prev) => {
          return true;
        });
      }
    }
  };

  const handleEdit = (data) => () => {
    setEditType("UPDATE");
    if (data?.DataEditTitle === "Update Address") {
      setAddressEditData(data);
      setDisplayUpdateAddress(true);
      return;
    }
    setCurrentData(data);
    setDisplayEditDiv(true);
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("..");
    }
  };

  const [status, setStatus] = useState(null);
  const [activity, setActivity] = useState("");
  const [comment, setComment] = useState("");

  // Derive activity options instead of storing them in state (prevents feedback loops / extra renders).
  const activityOptions = useMemo(() => {
    return status ? (statusActivityMap?.[status] || []) : [];
  }, [status, statusActivityMap]);

  useEffect(() => {
    // Timesheets depend on view selection, so keep it in its own effect.
    fetchTimesheetData();
    return () => undefined;
  }, [jobno, selectedValue]);

  // define onValueChange functions
  const handleStatusChange = useCallback(
    (value) => {
      setStatus(value);
      // Reset activity when status changes to avoid mismatched selections
      setActivity("");
    },
    []
  );

  const handleActivityChange = (value) => {
    setActivity(value);
  };

  // handle comment change
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  //handle Post Btn Click
  const handlePostBtnClick = async () => {
    if (comment.trim() === "") {
      // if comment is empty, add 'invalid' class and don't open modal
      commentInputRef.current?.classList?.add("invalid");
      setTimeout(() => {
        commentInputRef.current?.classList?.remove("invalid");
      }, pulsatingTime);
      return "Invalid";
    } else {
      // if comment is not empty, remove 'invalid' class if it exists
      commentInputRef.current?.classList?.remove("invalid");

      // directly handle confirmation without opening the modal
      handleConfirmationClick();
    }
  };

  const handleValueChange = (newValue) => {
    setSelectedValue(newValue);
  };

  // handle Confirmation click
  const handleConfirmationClick = async () => {
    setLoading(true);

    try {
      const CommentLog = {
        jobno,
        status,
        activity,
        comment,
        email: account.username,
      };

      const data = await dispatch(postProjectComment(CommentLog)).unwrap();

      // Clear form fields after successful submission
      setStatus("");
      setActivity("");
      setComment("");

      // Set the appropriate success message
      setApiResponse(data?.message || 'Comment submitted.');
    } catch (error) {
      console.error("Error:", error);
      setApiResponse("Error occurred");
    } finally {
      setLoading(false);
      fetchDataRecords();
      fetchTimesheetData();
      fetchLogBook();
      setIsResponseShown(true);
    }
  };

  const handleSubmitPopUp = async () => {
    handlePostBtnClick();
    fetchDataRecords();
    fetchTimesheetData();
    fetchLogBook();
  };

  const handleUpdateClientSubmit = (formData) => {
    const modifiedFormData = {
      ...formData,
      projectNumber: jobno,
      completedBy: account.username,
    };

    setLoading(true);

    dispatch(postUpdateClient(modifiedFormData));

    setLoading(false);
    fetchDataRecords();
    fetchLogBook();

    setDisplayUpdateClientForm(false);
  }

  const handleAWFSubmit = async (formData) => {
    const modifiedFormData = {
      ...formData,
      completedBy: account.username,
    };

    setLoading(true);
    try {
      await dispatch(postAWF(modifiedFormData));
      enqueueSnackbar('Additional Work Form submitted successfully!', { variant: 'success' });
      setDisplayAWForm(false);
      fetchDataRecords();
      fetchTimesheetData();
      fetchLogBook();
      fetchPhaseList();
      fetchpInvoiceList();
    } catch (err) {
      enqueueSnackbar(err?.message || 'Failed to submit Additional Work Form.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }

  const handleSubcontractorSubmit = (formData) => {
    const modifiedFormData = {
      ...formData,
      completedBy: account.username,
    };

    setLoading(true);

    dispatch(postSubConForm(modifiedFormData));

    setLoading(false);
    fetchDataRecords();
    fetchLogBook();

    setDisplayAWForm(false);
  }

  const handleRequestFBPFP = async () => {
    setLoading(true);
    try {
      const response = await dispatch(postRequestFreshFBPandFP(jobno, account.username));
      if (response && response.success) {
        enqueueSnackbar('Request for fresh FBP/FP sent successfully!', { variant: 'success' });
      } else {
        enqueueSnackbar('Failed to request fresh FBP/FP.', { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Failed to request fresh FBP/FP.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }

  const handleMapOpen = (address) => {
    const query = encodeURIComponent(address);
    const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
    window.open(url, "_blank");
  };

  const handleRunTsdAutomation = async () => {
    if (!jobno) return;
    setTsdLoading(true);
    try {
      const result = await dispatch(sendProjectToVm(jobno, account.username));
      enqueueSnackbar(result?.message || 'TSD Automation triggered successfully!', { variant: 'success' });
    } catch (err) {
      console.error(err);
      enqueueSnackbar(err?.message || 'Failed to trigger TSD Automation.', { variant: 'error' });
    } finally {
      setTsdLoading(false);
    }
  };

  const handleAddphase = () => {
    setSelectedPhase({});
    setIsUpdatingPhase(false);
    setPhaseModal(true);
  };

  const handlePhaseRowEdit = (row, phaseID, index) => {
    const selectedPhase = phaseListData.data.find(
      (row) => row.phaseID == phaseID
    );
    setSelectedPhase(selectedPhase);
    setIsUpdatingPhase(true);
    setPhaseModal(true);
  };

  const handleAddPInvoice = () => {
    setSelectedPInvoice({});
    setIsUpdatingPInvoice(false);
    setpInvoiceModal(true);
  };

  const handlePInvoiceRowEdit = (row, invoiceID, index) => {
    console.log(row, invoiceID, index, "row, invoiceID, index");
    const selectedInvoice = pInvoiceListData.data.find(
      (row) => row.invoiceID == invoiceID
    );
    setSelectedPInvoice(selectedInvoice);
    setIsUpdatingPInvoice(true);
    setpInvoiceModal(true);
  };

  const handlePInvoiceRowDelete = (rowIndex) => {
    dispatch(deleteBillingPlan(rowIndex, fetchpInvoiceList));
  };

  const handleAddBillPayerModal = () => {
    setAddBillPayerModal(true);
  };

  const handleRaiseInvoice = () => {
    window.location.href = `/invoicing/raise-invoice?jobNumber=${jobno}&status=start`;
  };

  return (
    <div className='projectProfileContent'>
      <div className='ProjectBaseInfo'>
        <div className='BackBtn' onClick={handleBack}>
          <img src={BackBtn} alt='Back' />
        </div>
        <div className="Topbar">
          <div className="TopbarInner">
            <div className="ButtonsWrapper">
              <ul className="TopbarList">
                {['Logbook', 'Tasks', 'Timesheets', 'Invoicing'].map((tab) => (
                  <li key={tab}>
                    <div
                      className={`${tab === activeTab ? 'TopbarTab ClickedOn' : 'TopbarTab'}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </div>
                  </li>
                ))}
              </ul>
              <div className="line"></div>
            </div>
          </div>
        </div>
      </div>
      <div className='ProjectAddress'>
        {jobData ? `${jobData.job_no} - ${jobData.address}` : "Loading..."}
        <img
          className='pinIcon'
          onClick={() => handleMapOpen(jobData.address)}
          src={MapPin}
          alt="MapPinAddress"
        />
        {editable && jobData && <img className='editIcon Address' onClick={handleEdit(addressEditInfo)} src={EditIcon} alt="EditIconAddress" />}
      </div>
      <div className='ProjectArchitect'>
        {jobData && jobData.architect ? (
          <Link to={`/clients/clientProfile#${jobData.architect_id}`} className='no-style-link'>
            {jobData.architect}
          </Link>
        ) : "Architect not found"}
        {editable && jobData && <img className='editIcon Client' onClick={() => setDisplayUpdateClientForm(true)} src={EditIcon} alt="EditIconClient" />}

      </div>
      <div className='ProjectTags'>

        {/* Project Tags */}
        {jobData && jobData.project_tag && jobData.project_tag.length > 0 && (
          <ul>
            {/* Remove duplicates in project_tag array before rendering */}
            {[...new Set(jobData.project_tag)].map(tag => {
              // Remove "(On/Off)" and trim spaces
              const cleanedTag = tag.replace(/\(On\/Off\)/g, '').trim();
              return (
                <li className='Tag' key={cleanedTag}>{cleanedTag}</li>
              );
            })}
          </ul>
        )}

        <div className='LeftAlignment'>

          {/* Project Folder Link */}
          {jobData && (
            <ul>
              <li className={`ProjectFolderBtn ${jobData && jobData.folder_link ? '' : 'disabled'}`}
                onClick={() => {
                  if (jobData && jobData.folder_link) {
                    window.open(jobData.folder_link, '_blank');
                  }
                }}
              >
                <img className='folderIcon' src={FolderIcon} alt='FolderIcon' />
              </li>
            </ul>
          )}




          {/* Status Bubble */}
          {!loading && jobData && jobData.status ? (
            <li className={`${jobData.status === 'LIVE' ? 'LiveBubble' : jobData.status === 'COMPLETE' ? 'CompleteBubble' : jobData.status === 'ON HOLD' ? 'OnHoldBubble' : jobData.status === 'OPP' ? 'OppBubble' : 'DormantBubble'} StatusTag`}>
              {jobData.status}
            </li>
          ) : (
            <li className='PlaceHolderBubble' />
          )}
        </div>
      </div>

      <div className="ProjectProfileScrollableArea">
        <div className='ProjectInformation' style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', flexWrap: 'wrap', alignItems: 'center', width: '100%' }}>

          <div className='ProjectStageInfo'>
            {editable && jobData && <img className='editIcon ProjectInfo' onClick={handleEdit(runnerTeamEditInfo)} src={EditIcon} alt="EditIcon" />}

            <div className='HorBlock1'>
              <div className="FieldContainer">
                <div className='Team FieldTitle'>Team:</div>
                <span className='InfoText'>{jobData && jobData.team ? jobData.team : '--'}</span>
              </div>
              <div className="FieldContainer">
                <div className='Runner FieldTitle'>Runner:</div>
                <span className='InfoText'>{jobData && jobData.runner ? jobData.runner : '--'}</span>
              </div>
            </div>

            <div className='HorBlock3'>
              <div className="FieldContainer">
                <div className='JobType FieldTitle'>Job Type: </div>
                <span className='InfoText'>{jobData && jobData.job_type ? jobData.job_type : '--'}</span>
              </div>
              <div className="FieldContainer">
                <div className='NextIssueDate FieldTitle'>Next Issue:</div>
                <span className='InfoText'>
                  {jobData && jobData.next_issue ? (
                    jobData.next_issue === '31/12/9999' ? 'Not Set' : jobData.next_issue
                  ) : 'None'}
                </span>
              </div>
            </div>
          </div>

          <div className='ProjectStats'>
            {editable && jobData && <img className='editIcon ProjectStat' onClick={handleEdit(statsEditInfo)} src={EditIcon} alt="EditIcon" />}

            <div className='HorBlock1'>
              <div className="FieldContainer">
                <div className='JobFee FieldTitle'> {jobData && ['LOST OPP', 'OPP'].includes(jobData.status) ? 'Quoted Fee:' : 'Job Fee:'} </div>
                <span className='InfoText'>
                  {jobData && ['LOST OPP', 'OPP'].includes(jobData.status) && jobData.quoted
                    ? `£${Math.round(jobData.quoted).toLocaleString('en-GB')}`
                    : jobData
                      ? `£${Math.round(jobData.fee).toLocaleString('en-GB')}`
                      : ''
                  }
                </span>
              </div>
              <div className="FieldContainer">
                <div className='inv FieldTitle'>Rem. Inv:</div>
                <span className='InfoText'>
                  {jobData && jobData.rem_inv ? `£${jobData.rem_inv.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : '£0'}
                </span>
              </div>
            </div>

            <div className='HorBlock3'>
              <div className="FieldContainer">
                <div className='pFB FieldTitle'>pFB:</div>
                <span className='InfoText'>
                  {jobData && jobData.pFB !== 199 ? Math.round(jobData.pFB) + '%' : '--'}
                </span>
              </div>
              <div className="FieldContainer">
                <div className='FB FieldTitle'>FB:</div>
                <span className='InfoText'>{jobData && jobData.FB ? Math.round(jobData.FB) + '%' : '--'}</span>
              </div>
            </div>
          </div>

          <div className='ProjectBtns' style={{ marginLeft: 'auto' }}>
            <div className='ProjectBtnsContainer' style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div style={{ display: 'flex', gap: '6px' }}>
                <div className="FieldContainer">
                  <div
                    className={`AddWorks LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : () => setDisplayAWForm(true)}
                  >
                    ADD WORKS
                  </div>
                </div>

                <div className="FieldContainer">
                  <div
                    className={`AddWorks LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : () => setDisplaySubconForm(true)}
                  >
                    ADD SUBCONTRACTOR
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '6px' }}>
                <div className='FieldContainer'>
                  <div
                    className={`Triage LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : () => setShowTriageModal(true)}
                  >
                    BOOK TRIAGE
                  </div>
                </div>

                <div className='FieldContainer'>
                  <div
                    className={`Triage LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : () => setShowRisksOptions(true)}
                  >
                    ROO FORM
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '6px' }}>
                <div className='FieldContainer'>
                  <div
                    className={`Triage LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : () => setShowStructuralSpec(true)}
                  >
                    STRUCTURAL SPEC
                  </div>
                </div>

                <div className='FieldContainer'>
                  <div
                    className={`Triage LongBtn ${!jobData ? 'disabled' : ''}`}
                    onClick={!jobData ? null : handleRequestFBPFP}
                  >
                    REQUEST FBP/FP
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '6px' }}>
                <div className='FieldContainer'>
                  <div
                    className={`Triage LongBtn ${!jobData || tsdLoading ? 'disabled' : ''}`}
                    onClick={!jobData || tsdLoading ? null : handleRunTsdAutomation}
                    style={{ opacity: tsdLoading ? 0.6 : 1, cursor: tsdLoading ? 'not-allowed' : 'pointer' }}
                  >
                    {tsdLoading ? 'RUNNING TSD...' : 'RUN TSD AUTOMATION'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {activeTab === 'Logbook' && (
          <>
            <div className="SubTitle" style={{ marginTop: '20px' }}> Log Book </div>

            <div className="CommentsArea">
              <div className="CommentsSection">
                <p className="Status">
                  Status:{" "}
                  <span className="Dropdown">
                    <Dropdown
                      options={status_type_options}
                      selectedValue={
                        jobData
                          ? jobData.status === "On-hold"
                            ? formatStatus(status)
                            : titleCase(status)
                          : ""
                      }
                      onValueChange={handleStatusChange}
                    />
                  </span>
                </p>

                <p className="Activity">
                  Activity:{" "}
                  <span className="Dropdown">
                    <Dropdown
                      options={activityOptions}
                      selectedValue={activity}
                      options_width='110%'
                      onValueChange={handleActivityChange} // update selected activity when a new one is chosen
                    />
                  </span>
                </p>

                <p className="Comment">
                  Comment:
                  <textarea
                    className="CommentInput"
                    ref={commentInputRef}
                    placeholder={comment ? "" : "Comment..."}
                    onFocus={(e) => (e.target.placeholder = "")}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.placeholder = "Comment...";
                    }}
                    wrap="hard"
                    value={comment}
                    onChange={handleCommentChange}
                  />
                </p>

                <p className="Post">
                  {status === "On-hold" ? (
                    <button
                      className={`PostBtn ${!jobData ? "disabled" : ""}`}
                      onClick={!jobData ? null : handleEdit(FollowUpEditInfo)}
                    >
                      POST
                    </button>
                  ) : status === "Opp" && activity === "Opp Update" ? (
                    <button
                      className={`PostBtn ${!jobData ? "disabled" : ""}`}
                      onClick={!jobData ? null : () => setFollowUpModal(true)} // Open modal if status is "Opp" and activity is "Opp Update"
                    >
                      POST
                    </button>
                  ) : status === "Opp" && activity === "Appointed" ? (
                    <button
                      className={`PostBtn ${!jobData ? "disabled" : ""}`}
                      onClick={!jobData ? null : () => setPromoteModal(true)} // Open modal if status is "Opp" and activity is "Appointed"
                    >
                      POST
                    </button>
                  ) : status === "Opp" && activity === "Lost" ? (
                    <button
                      className={`PostBtn ${!jobData ? "disabled" : ""}`}
                      onClick={!jobData ? null : () => setLostOppModal(true)} // Open modal if status is "Opp" and activity is "Lost"
                    >
                      POST
                    </button>
                  ) : (
                    <button
                      className={`PostBtn ${!jobData ? "disabled" : ""}`}
                      onClick={!jobData ? null : handlePostBtnClick}
                    >
                      POST
                    </button>
                  )}
                </p>

                <FollowUpPopUp
                  isVisible={followUpModal}
                  jobNumber={jobno}
                  onSubmit={handleSubmitPopUp}
                  onClose={() => setFollowUpModal(false)}
                />
                <AppointedPopUp
                  isVisible={promoteModal}
                  jobNumber={jobno}
                  runners={Array.isArray(runnerOptions) ? runnerOptions : []}
                  onSubmit={handleSubmitPopUp}
                  onClose={() => setPromoteModal(false)}
                />
                <LostOppPopUp
                  isVisible={lostOppModal}
                  jobNumber={jobno}
                  reasons={lostReasons}
                  onSubmit={handleSubmitPopUp}
                  onClose={() => setLostOppModal(false)}
                />
              </div>
            </div>


            <div id="Logbook" className="LogBook">
              <div className="LogBookTable">
                <table>
                  <tbody>
                    {isLogBookLoading
                      ? Array(8)
                        .fill()
                        .map((_, index) => (
                          <tr className="LogRow" key={index}>
                            <td
                              className="LogStatus"
                              style={{ marginLeft: "15px" }}
                            >
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={108}
                                height={25}
                              />
                            </td>
                            <td
                              className="LogActivity"
                              style={{ marginLeft: "-220px" }}
                            >
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={120}
                                height={20}
                              />
                            </td>
                            <td
                              className="LogComments wide"
                              style={{ marginLeft: "-130px" }}
                            >
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={500}
                                height={20}
                              />
                            </td>
                            <td
                              className="LogDescription"
                              style={{ marginLeft: "-30px" }}
                            >
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={300}
                                height={20}
                              />
                            </td>
                          </tr>
                        ))
                      : logBook &&
                      logBook.map((log) => (
                        <tr className="LogRow" key={log.id}>
                          <td
                            className={`${log.status.toUpperCase() === "LIVE"
                              ? "LiveBubble"
                              : log.status.toUpperCase() === "COMPLETE"
                                ? "CompleteBubble"
                                : log.status.toUpperCase() === "ON-HOLD"
                                  ? "OnHoldBubble"
                                  : log.status.toUpperCase() === "OPP"
                                    ? "OppBubble"
                                    : log.status.toUpperCase() === "INVOICE"
                                      ? "InvBubble"
                                      : "DormantBubble"
                              } LogStatus`}
                          >
                            {log.status.toUpperCase()}
                          </td>
                          <td className="LogActivity wide">
                            {log.activity_type}
                          </td>
                          <td className="LogComments wide">{log.comments}</td>
                          <td className="LogDescription">{log.description}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {activeTab === 'Invoicing' && (
          <Grid container spacing={4}>
            <Grid item md={6} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                style={{ marginTop: "10px" }}
              >
                <div className="SubTitle" style={{ marginBottom: "5px" }}>
                  {" "}
                  Phases{" "}
                </div>
                {
                  editable &&
                  <div
                    className="addBillPayer LongBtn SubTitle"
                    style={{ width: '100px' }}
                    onClick={handleAddphase}
                  >
                    ADD PHASE
                  </div>
                }
              </Stack>

              <div
                style={{
                  marginBottom: "0px",
                }}
              >
                {jobData && !phaseListLoading ? (
                  <PhaseTable
                    jsonData={phaseListData}
                    headerMap={headerMapPhase}
                    handleRowEdit={handlePhaseRowEdit}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "calc(100% - 20%)",
                    }}
                  >
                    <CircularProgress size={65} />
                  </Box>
                )}
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                style={{ marginTop: "10px" }}
              >
                <div className="SubTitle" style={{ marginBottom: "5px", display: "flex", alignItems: "center" }}>
                  Planned/Invoiced
                  {jobData && (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '15px' }}>
                      <span style={{ fontSize: '16px', color: '#949494', marginRight: '5px', fontWeight: 'normal', fontFamily: 'PT Sans' }}>Invoiced:</span>
                      <div style={{ width: "80px" }}>
                        <ProgressBar
                          currentValue={jobData && jobData.FB ? parseFloat(jobData.FB) : 0}
                          maxValue={100}
                          displayMode={'percentage'}
                          variant={'blue'}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: "flex" }}>
                  {
                    editable &&
                    <React.Fragment>
                      <div
                        className="addBillPayer LongBtn SubTitle"
                        style={{ marginRight: "15px" }}
                        onClick={handleRaiseInvoice}
                      >
                        RAISED
                      </div>

                      <div
                        className="addBillPayer LongBtn SubTitle"
                        style={{ width: '100px' }}
                        onClick={handleAddPInvoice}
                      >
                        ADD PLANNED
                      </div>
                    </React.Fragment>
                  }
                </div>
              </Stack>

              <div
                style={{
                  marginBottom: "0px",
                }}
              >
                {pInvoiceListData && !pInvoiceListLoading ? (
                  <PlannedInvoicedTable
                    jsonData={pInvoiceListData}
                    headerMap={headerPlannedInvoiced}
                    handleRowEdit={handlePInvoiceRowEdit}
                    handleRowDelete={handlePInvoiceRowDelete}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "calc(100% - 20%)",
                    }}
                  >
                    <CircularProgress size={65} />
                  </Box>
                )}
              </div>
            </Grid>
            <Grid item md={12} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                style={{ marginTop: "10px" }}
              >
                <div className="SubTitle" style={{ marginBottom: "5px" }}>
                  {" "}
                  Clients
                </div>
                <div
                  className="addBillPayer LongBtn SubTitle"
                  style={{ width: '100px' }}
                  onClick={handleAddBillPayerModal}
                >
                  ADD CLIENT
                </div>
              </Stack>
              {billPayerData && !billPayerLoading ? (
                <BillPayerTable
                  rowD={billPayerData}
                  headerMap={headerBillPayer}
                  // handleRowEdit={handlePInvoiceRowEdit}
                  jobNumber={jobno}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "calc(100% - 20%)",
                  }}
                >
                  <CircularProgress size={65} />
                </Box>
              )}
            </Grid>
          </Grid>
        )}

        {activeTab === 'Timesheets' && (
          <Grid container spacing={4}>
            <Grid item md={12} xs={12}>
              <div className="SubTitle" style={{ marginTop: '20px' }}> Timesheet Views </div>
              <div style={{ marginBlock: "20px" }}>
                <HorizontalButtons
                  options={[
                    "SUMMARY - PHASE",
                    "SUMMARY - PERSON",
                    "INDIVIDUAL",
                    "PENDING",
                  ]}
                  selectedValue={selectedValue} // State to track selected value
                  onValueChange={handleValueChange} // Function to handle value change
                />
              </div>
              <div
                style={{
                  height: "400px",
                  maxHeight: "400px",
                  marginBottom: "24px",
                }}
              >
                {timesheetError ? (
                  <div style={{ padding: "12px", color: "#D32030", fontFamily: "PT Sans, sans-serif" }}>
                    {timesheetError}
                  </div>
                ) : jobData && !timesheetLoading ? (
                  <Table data={timesheetData} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "calc(100% - 20%)",
                    }}
                  >
                    <CircularProgress size={65} />
                  </Box>
                )}
              </div>
            </Grid>
          </Grid>
        )}

        {activeTab === 'Tasks' && (
          <PlannerTasksBoard
            tasks={plannerTasks.tasks}
            loading={plannerTasks.tasksLoading}
            error={plannerTasks.tasksError}
            userEmail={account?.username}
          />
        )}

        <div className="LastUpdated">{lastUpdated}</div>

        {displayUpdateClientForm && (
          <UpdateClientForm
            onSubmit={handleUpdateClientSubmit}
            onClose={() => setDisplayUpdateClientForm(false)}
          />
        )}

        {showTriageModal && (
          <TriageBookingModal
            isVisible={showTriageModal}
            onClose={() => setShowTriageModal(false)}
            jobNumber={jobData?.job_no}
            projectName={jobData?.address || jobData?.job_no}
            defaultName={account?.name}
            defaultEmail={account?.username}
          />
        )}

        {displayAWForm && (
          <AWForm
            projectNumber={jobData.job_no}
            team={jobData.team}
            onSubmit={handleAWFSubmit}
            onClose={() => setDisplayAWForm(false)}
          />
        )}

        {displaySubconForm && (
          <SubcontractorForm
            projectNumber={jobData.job_no}
            Runner={jobData.runner}
            Address={jobData.address}
            onSubmit={handleSubcontractorSubmit}
            onClose={() => setDisplaySubconForm(false)}
          />
        )}

        {showRisksOptions && (
          <RisksOptionsForm
            initialJobNumber={jobData?.job_no}
            onClose={() => setShowRisksOptions(false)}
            onSubmit={(data) => {
              console.log('Risks/Options/Opportunities submitted', data);
              setShowRisksOptions(false);
            }}
          />
        )}

        {showStructuralSpec && (
          <StructuralSpecificationForm
            initialJobNumber={jobData?.job_no}
            initialAddress={jobData?.address}
            onClose={() => setShowStructuralSpec(false)}
            onSubmit={(data) => {
              console.log('Structural Specification submitted', data);
              setShowStructuralSpec(false);
            }}
            defaultEmail={account?.username}
          />
        )}

        {displayUpdateAddress && (
          <UpdateAddressPopUp
            isVisible={displayUpdateAddress}
            data={addressEditData}
            onClose={() => setDisplayUpdateAddress(false)}
            onSubmit={(title, values) => handleUpdateClick(title, values)}
          />
        )}

        {displayEditDiv && (
          <EditDiv
            data={currentData}
            handleUpdateClick={handleUpdateClick}
            setDisplayEditDiv={setDisplayEditDiv}
            actionType={editType}
            required={true}
          />
        )}

        {loading && (
          <div className="ProjectProfile__Overlay">
            <div style={{ borderRadius: "150px", minWidth: "160px" }}>
              <CircularProgress size={65} />
            </div>
          </div>
        )}

        {isResponseShown && (
          <div className="ProjectProfile__Overlay">
            <div className="ProjectProfile__ResponseBox">
              <div
                style={{
                  fontSize: 16,
                  fontFamily: "PT Sans",
                  textAlign: "center",
                  margin: "20px",
                  marginLeft: "25px",
                  marginRight: "25px",
                }}
                dangerouslySetInnerHTML={{ __html: apiResponse }}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                {apiResponse?.includes("Warning!") ? (
                  <>
                    <div
                      className="ProjectProfile__Button"
                      onClick={() => {
                        setIsResponseShown(false);
                        InvoicedData[1]["Allowed"] = true;
                        handleUpdateClick(InvoicedData[0], InvoicedData[1]);
                      }}
                    >
                      CONFIRM
                    </div>
                    <div
                      className="ProjectProfile__Button"
                      onClick={() => setIsResponseShown(false)}
                    >
                      CANCEL
                    </div>
                  </>
                ) : (
                  <div
                    className="ProjectProfile__Button"
                    onClick={() => setIsResponseShown(false)}
                  >
                    OK
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {
        phaseModal && (
          <PhasePopUp
            isEdit={isUpdatingPhase}
            isVisible={phaseModal}
            onClose={() => setPhaseModal(false)}
            onRefresh={fetchPhaseList}
            jobNumber={jobno}
            selectedPhase={selectedPhase}
          />
        )
      }

      {
        pInvoiceModal && (
          <PlannedInvoicedPopUp
            isEdit={isUpdatingPInvoice}
            isVisible={pInvoiceModal}
            onClose={() => setpInvoiceModal(false)}
            onRefresh={fetchpInvoiceList}
            jobNumber={jobno}
            selectedPInvocied={selectedPInvocied}
          />
        )
      }

      {
        billPayerModal && (
          <AddBillPayerPopUp
            isVisible={billPayerModal}
            onClose={() => setAddBillPayerModal(false)}
            jobNumber={jobno}
            onRefresh={fetchBillPayers}
          />
        )
      }
    </div >
  );
}

export default ProjectProfile;
const headerMapPhase = {
  phaseID: "",
  phaseName: "Phase Name",
  phaseAmount: "Phase Amt",
  invoicedAmount: "Inv Amt",
  status: "Status",
  phaseDate: "Promoted Date",
  comment: "Comment",
};

const headerPlannedInvoiced = {
  invoiceID: "",
  plannedDate: "Planned Date",
  plannedAmount: "Planned Amt",
  invoicedAmount: "Invoiced Amt",
  invoiceNo: "Invoice No.",
  paidDate: "Paid Date",
  comment: "Comment",
  // planID2: "",
};

const headerBillPayer = {
  default: "Bill Payer",
  name: "Name",
  clientType: "Type",
  email: "Email",
  address: "Address",
  // billPayerID: "",
  // contactNo: "Contact No",
};
